import { useCallback, useMemo } from 'react';

import { AppServiceFactory } from '@modules/app/service/AppServiceFactory';

import { useCanvasStore } from '../../store';

export const useToolEnd = () => {
  const appSvc = useMemo(() => AppServiceFactory.getInstance().createAppService(), []);

  const toolEnded = useCallback(() => {
    const canvas = useCanvasStore.getState().instance;
    if (!canvas) return;

    appSvc.resetTool();
  }, [appSvc]);

  return { toolEnded };
};
